<template>
    <div class="layout-feature">
        <div class="uk-inline inline-hero uk-visible@m">
            <img :src="page.heroImage.large" :alt="page.title" >
        </div>

        <FloatingBadge :text="page.subtitle" :badgeClass="'background-blue text-white'" v-if="page.subtitle"/>

        <div class="uk-section uk-section uk-text-center uk-light uk-background-darkest">
            <div class="uk-container uk-container-small uk-text-center">
                <h1 class="uk-margin-remove-top"><b>{{page.title}}</b></h1>
                <p class="uk-text-lead text-white">{{page.summary}}</p>
            </div>
        </div>

        <div class="uk-background-footer uk-light">
            <div class="uk-flex uk-grid-collapse" uk-grid>
                <div class="uk-width-1-2@m uk-width-1-1@s">
                    <div class="flex-video widescreen" v-html="page.secondaryContent"></div>
                </div>
                <div class="uk-width-1-2@m uk-width-1-1@s">
                    <div class="uk-tile uk-padding-large uk-text-center">

                        <p class="uk-text-lead">
                            A documentary film and curriculum that addresses the need for ALL students in America to have equal access to quality education.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-section background-yellow uk-text-center">
            <h1 class="uk-margin-remove"><b>#TeachUsAll</b></h1>
        </div>

        <div class="uk-section uk-section-medium uk-background-white" v-if="page.content">
            <div class="uk-container uk-container-small">
                <div class="content" v-html="page.content"></div>
            </div>
        </div>

        <Testimonials :testimonials="(page && page.testimonialsArray) ? JSON.parse(page.testimonialsArray, true) : false" />

    </div>
</template>

<script>
export default {
    props: ['page', 'parent']
}
</script>
